import React, { ChangeEvent, useEffect, useState } from "react"
import clsx from "clsx"
import Container from "@ecom/ui/components/Container"
import Slider from "@material-ui/core/Slider"
import Button from "@material-ui/core/Button"
import cn from "classnames"
import { CheckboxBlock } from "./CheckboxBlock"
import { AuraCard, PlanetaCard, DefaultCard } from "./images"

import scrollToPersonalForm from "../../helpers/scrollToPersonalForm"
import { DLClickEventExtended } from "../../helpers/WatcherDL/DLEvents"
import { calculateSum } from "./helpers/calculate"

import * as styles from "./newCalculator.module.scss"

interface CalculatorProps {
  subtitle?: React.ReactNode
  orderNum?: string
  title?: React.ReactNode
  textSlider?: string
  variantStyles?: string
  buttonCtaText?: string
  textTooltip?: React.ReactNode
  btnCustomColor?: boolean
}

const defSubTitle = (
  <>
    До 10% кешбэка с покупок. <br className="d-sm-none" />
    Воспользуйтесь&nbsp;калькулятором&nbsp;и&nbsp;узнайте, <br className="d-md-none" />
    как вернуть до 60 000₽ в год
  </>
)

const defTitle = (
  <>
    Рассчитайте выгоду <br className="d-sm-none" />
    от карты «Халва»
  </>
)

const renderImage = (variantStyles: string | undefined) => {
  switch (variantStyles) {
    case "planeta":
      return <PlanetaCard alt="planetacard" className={styles.cardImg} />
    case "aura":
      return <AuraCard alt="auracard" className={styles.cardImg} />
    default:
      return <DefaultCard alt="card" className={styles.cardImg} />
  }
}

export const NewCalculator = ({
  subtitle = defSubTitle,
  title = defTitle,
  orderNum,
  textSlider = "Сумма покупки у партнеров",
  variantStyles,
  buttonCtaText = "Оформить карту",
  textTooltip,
  btnCustomColor,
}: CalculatorProps) => {
  const [spending, setSpending] = useState<number | number[]>(10000)
  const [halvaDesyatka, setHalvaDesyatka] = useState(true)
  const [sum, setSum] = useState(500)

  const handleClick = () => {
    DLClickEventExtended({
      name: buttonCtaText,
      eventAction: "CTA в калькуляторе",
      placement: "calculator",
    })

    scrollToPersonalForm()
  }

  const onChangeSpending = (_: ChangeEvent<{}>, value: number | number[]) => {
    setSpending(value)
  }

  const onChangeCommitted = (_: ChangeEvent<{}>, value: number | number[]) => {
    const numericValue = typeof value === "number" ? value : value[0]
    DLClickEventExtended({
      name: "Сумма покупки",
      eventCategory: "monthly_spending_calc",
      eventAction: String(numericValue),
      placement: "calculator",
    })
  }

  const onChangeCheckbox = () => {
    // setTimeout для INP
    setTimeout(() => {
      DLClickEventExtended({
        name: "halva_desyatka_check",
        placement: "calculator",
        eventAction: halvaDesyatka ? "off" : "on",
      })
    }, 0)

    setHalvaDesyatka((prev) => !prev)
  }

  useEffect(() => {
    setSum(calculateSum(halvaDesyatka, +spending))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [halvaDesyatka, spending])

  return (
    <section
      className={clsx(styles.section, variantStyles && styles[variantStyles])}
      id="calculator"
      data-exclude={orderNum}
    >
      <Container className={styles.container}>
        <h2 className={styles.head}>{title}</h2>
        <p className={styles.descr}>{subtitle}</p>
        <div className={styles.content}>
          <div className={styles.sliderContainer}>
            <p className={styles.sliderDescr}>{textSlider}</p>
            <div className={styles.sliderSum}>{spending.toLocaleString().replace(/,/g, " ")} ₽</div>
            <Slider
              value={spending}
              onChange={onChangeSpending}
              onChangeCommitted={onChangeCommitted}
              max={100000}
              step={10000}
              classes={{
                root: styles.slider,
                track: styles.track,
                thumb: styles.thumb,
                rail: styles.rail,
              }}
            />
            <CheckboxBlock
              variantStyles={variantStyles}
              checkboxActive={halvaDesyatka}
              onChangeCheckbox={onChangeCheckbox}
              textTooltip={textTooltip}
            />
            <div className={cn(styles.disclaimer, "d-none d-md-block")}>
              Предварительный расчет. Не является публичной офертой
            </div>
          </div>
          <div className={styles.card} id="calculatorCard">
            {renderImage(variantStyles)}
            <div>
              <div className={styles.cardText}>
                <p>Ваша прибыль</p>
                <div className={styles.sum}>
                  {sum.toLocaleString().replace(/,/g, " ")} <span>₽</span>
                </div>
              </div>
              <Button
                className={btnCustomColor && styles.btnCustomColor}
                onClick={handleClick}
                classes={{ root: styles.btn }}
              >
                {buttonCtaText}
              </Button>
            </div>
          </div>
          <div className={cn(styles.disclaimer, "d-md-none")}>
            Предварительный расчет. <br className="d-sm-none" />
            Не является публичной офертой
          </div>
        </div>
      </Container>
    </section>
  )
}
